const projectSettings = {
  archivedBanner:
    "Þetta verkefni er í geymslu, sem þýðir að það er eingöngu til skoðunar. Endurvektu það undir Verkefnastýringu til að gera breytingar.",
  loading: "Hleð stillingum…",
  details: {
    title: "Verkefnaupplýsingar",
    description: "Nafn og lýsing verkefnisins sem allir þátttakendur sjá.",
    titleLabel: "Heiti",
    saveButton: "Vista upplýsingar",
    saving: "Vista…",
    saved: "Verkefnaupplýsingar vistaðar.",
  },
  settings: {
    title: "Verkefnastillingar",
    description:
      "Stilltu sjálfgefna hegðun fyrir gagnaaðgang og tilkynningar í þessu verkefni.",
    saveButton: "Vista stillingar",
    saving: "Vista…",
    saved: "Stillingar vistaðar.",
  },
  researcherAccess: {
    title: "Sjálfgefinn aðgangur rannsakanda",
    description:
      "Hvernig gagnasöfn sem hlaðið er upp í þessu verkefni eru aðgengileg rannsakendum.",
    piApproval: "Krefjast gagnabeiðni (samþykki verkefnisstjóra)",
    autoGrant: "Veita verkefnisfélögum sjálfkrafa aðgang",
  },
  catalogVisibility: {
    title: "Sjálfgefinn sýnileiki í yfirliti gagnasafna",
    description:
      "Hverjir geta fundið gagnasöfn sem hlaðið er upp í þessu verkefni.",
    projects: "Þetta verkefni",
    org: "Allir í stofnuninni þinni",
    hidden: "Falið",
  },
  autoNotify: {
    title: "Senda tilkynningu sjálfkrafa við innhleðslu",
    description:
      "Tilkynna beiðanda og verkefnisstjórum sjálfkrafa þegar gögnum er hlaðið upp.",
  },
  controls: {
    title: "Verkefnastýring",
  },
  archive: {
    restoreTitle: "Endurvekja verkefni",
    restoreDescription:
      "Endurvektu verkefnið til að færa það aftur á lista yfir virk verkefni",
    archiveTitle: "Setja verkefni í geymslu",
    archiveDescription:
      "Leggðu þetta verkefni til hliðar: það hverfur af sjálfgefnum verkefnalistum. Engu er eytt og þú getur endurvakið það hvenær sem er.",
    restoreButton: "Endurvekja verkefni",
    restoring: "Endurvek…",
    archiveButton: "Setja í geymslu",
    confirmArchive: "Staðfesta geymslu",
    archiving: "Set í geymslu…",
  },
  leave: {
    title: "Yfirgefa verkefni",
    description:
      "Fjarlægðu sjálfan þig úr þessu verkefni. Þú missir aðgang nema þér sé boðið aftur.",
    onlyPiDescription:
      "Þú ert eini verkefnisstjórinn í þessu verkefni. Úthlutaðu öðrum verkefnisstjóra áður en þú getur yfirgefið það.",
    onlyPiHint: "Úthlutaðu öðrum verkefnisstjóra áður en þú yfirgefur verkefnið",
    leaveButton: "Yfirgefa verkefni",
    confirmLeave: "Staðfesta brottför",
    leaving: "Yfirgef…",
  },
  errors: {
    loadFailed: "Ekki tókst að hlaða stillingum",
    titleRequired: "Heiti er nauðsynlegt.",
    saveDetailsFailed: "Ekki tókst að vista verkefnaupplýsingar",
    saveSettingsFailed: "Ekki tókst að vista stillingar",
  },
};

export default projectSettings;
